export default "__VITE_ASSET__BcAXPH3V__"